<template>
  <div style="height: 100%; width: 100%; background-color: #525659">
    <div class="main-container f-column" @contextmenu.prevent="kong()">
      <!--泰豪-->
      <div style="position: absolute; width: 100%; height: 100%; z-index: 999" v-if="tellhow">
        <!--时间-->
        <div style="
            position: absolute;
            width: 10%;
            height: 7%;
            left: 70%;
            display: flex;
          ">
          <div style="position: absolute; top: 25%">
            <span style="color: #ececec; font-size: 2vh">{{ hours }} : {{ minutes }}
              :
              {{ seconds }}</span>
          </div>
          <div style="position: absolute; left: 56%; top: 15%; color: #e8e8e8">
            <span>---- 星期 四</span><br /><span>2021/04/15</span>
          </div>
        </div>
        <!--退出按钮-->
        <div @click="gobackIndex" style="
            position: absolute;
            width: 4%;
            height: 3%;
            left: 94.5%;
            top: 2%;
            cursor: pointer;
          "></div>
        <!--泰豪首页-->
        <div style="
            width: 100%;
            height: 100%;
            background-image: url('/static/img/homepage/tellhow1.png');
            background-size: 100% 100%;
          " v-if="tellhowIndex">
          <div @click="suzhouMap" style="
              position: absolute;
              width: 30px;
              height: 30px;
              background-size: 100% 100%;
              background-image: url('/static/tellhow/images/xm.gif');
              left: 67%;
              top: 73%;
              cursor: pointer;
            "></div>
          <div style="
              position: absolute;
              width: 30px;
              height: 30px;
              background-size: 100% 100%;
              background-image: url('/static/tellhow/images/xm3.gif');
              left: 63.2%;
              top: 43%;
              cursor: pointer;
            "></div>
          <div style="
              position: absolute;
              width: 30px;
              height: 30px;
              background-size: 100% 100%;
              background-image: url('/static/tellhow/images/xm.gif');
              left: 50.2%;
              top: 65%;
              cursor: pointer;
            "></div>
          <div style="
              position: absolute;
              width: 30px;
              height: 30px;
              background-size: 100% 100%;
              background-image: url('/static/tellhow/images/xm.gif');
              left: 32.8%;
              top: 34%;
              cursor: pointer;
            "></div>
        </div>
        <!--泰豪苏州-->
        <div style="
            width: 100%;
            height: 100%;
            background-image: url('/static/img/homepage/tellhowsu.png');
            background-size: 100% 100%;
          " v-if="tellhowSuMap">
          <div @click="modelShow" class="tellhowBt" style="
              position: absolute;
              width: 30px;
              height: 30px;
              background-size: 100% 100%;
              background-image: url('/static/tellhow/images/xm.gif');
              left: 45%;
              top: 23%;
              cursor: pointer;
            ">
            <!--<el-popover
              placement="bottom"
              title=""
              width="200"
              trigger="hover"
              content="这是一段内容,这是一段内容,这是一段内容,这是一段内容。">
              <div style="">
                <el-button  @click="suzhouhuiyishi"  size="small" type="warning" round style="margin-left: 6%">会议室场景</el-button>
                <el-button  @click="lengdongzhan"  size="small" type="primary" round style="margin-top: 3%">冷冻站场景</el-button>
                <el-button @click="changfang"  size="small" type="success" round style="margin-top: 3%">厂房场景</el-button>
              </div>
              <el-button slot="reference"></el-button>
              在这样下去
            </el-popover>-->
          </div>
        </div>
      </div>
      <!--智慧灯杆页面-->
      <div style="position: absolute; width: 100%; height: 100%; z-index: 999" v-if="wisdowShow">
        <div style="
            position: absolute;
            color: #049dac;
            font-size: 2vh;
            top: 2%;
            left: 1%;
            cursor: pointer;
          " @click="wisdowBack">
          返回
        </div>
        <iframe align="center" width="100%" height="1200" src="../../static/wisdom/index.html" frameborder="no"
          border="0" marginwidth="0" marginheight="0" scrolling="no"></iframe>
      </div>
      <!--logo区域----- @contextmenu.prevent="kong()"-->
      <div class="main-header f-full">
        <!--   <div
          class="main-title f-full"
          style="float: left"
        >
          <span
            class="main-toggle fa fa-bars"
            @click="left_toggle()"
          ><img
              style="height: 13px"
              :src="toggle"
            ></span>
          <span style="font-size: 17px;font-weight: 700;margin-left: -1%;color: white">&nbsp;&nbsp;&nbsp;AIM&nbsp;&nbsp;FOCUS</span>
          <span style="font-size: 19px;color: #e2e2e2">&nbsp;|</span>
          <span style="font-size: 14px;color: #e2e2e2">&nbsp;物联网基础数据管理工具&nbsp;&nbsp;</span>
          <span class="main-userInfo">
            <span style="position:relative;top:6px;margin-right:20px">
              <el-badge
                :value="alarmNum"
                class="item"
                type="warning"
                v-if="alarmNum === 0"
                :hidden="true"
              >
                <img
                  @click="bottom_toggle()"
                  :src="police"
                  style="width: 24px;height: 24px;"
                >
              </el-badge>

            </span>

            <span style="position:relative;top:5px;margin-right:8px;left: 5px"><img
                width="19"
                height="19"
                :src="user"
              ></span>
            <span style="margin-right:28px;font-size: 13px;color: #fdfdfd;margin-top:8px;line-height:36px">{{ username }}</span>
            <span style="position:absolute;top:8px;left: -65%"><img
                width="18"
                height="18"
                style='cursor: pointer;'
                :src="lianjie"
                @click="test"
              ></span>
            <span style="position:absolute;top:6px;left: -48%;color: #fdfdfd;font-size: 10px;line-height:25px">支持</span>
            <el-dropdown
              trigger="click"
              style="position: absolute;margin-top:3.5px;left: -10%"
            >
              <span class="el-dropdown-link">
                <img
                  :src="model"
                  style="width:16px;height:16px;position:absolute;top:5px;left: -25px;line-height:25px;cursor: pointer;"
                >

              </span>
              <span style="font-size: 10px;color: #fdfdfd">应用</span>
              <el-dropdown-menu slot="dropdown">
                <div @click="open()">
                  <el-dropdown-item class="clearfix">
                    门禁管理
                  </el-dropdown-item>
                </div>
                <div @click="users()">
                  <el-dropdown-item class="clearfix">
                    用户管理
                  </el-dropdown-item>
                </div>

                <div @click="timeSynchronization()">
                  <el-dropdown-item class="clearfix">
                    时间同步
                  </el-dropdown-item>
                </div>
                <div @click="onlineChartTraffic()">
                  <el-dropdown-item class="clearfix">
                    信号灯曲线
                  </el-dropdown-item>
                </div>

              </el-dropdown-menu>
            </el-dropdown>
            <span style="position:relative;top:5px;margin-right:8px"><img
                width="18"
                height="18"
                style='cursor: pointer;'
                :src="logoutIcon"
                @click="logout"
              ></span>
          </span>
        </div> -->
        <div class="collapse-btn">
          <img style="height: 13px" :src="toggle" />
        </div>
        <!-- <div class="logo comp"><img src='../../static/img/aim-icon/logo.png' width="96px" height="21px"/></div> -->
        <!-- <div class="logo comp">LopeNet</div> -->
        <div class="logo comp">IOTDCS</div>
        <div class="logo symb">|</div>
        <div class="logo tit">物联网基础数据管理工具</div>
        <div class="header-right">
          <div class="header-user-con">
            <div @click="searchSnClick" style="display: flex; align-items: center">
              <div class="support" style="margin-top: -1px">
                <i class="el-icon-search" style="font-size: 20px; color: #07c160; cursor: pointer"></i>
              </div>
              <div class="user-name">查询设备</div>
            </div>

            <div class="support" style="margin-top: -1px">
              <!-- <img width="23" height="22" style="cursor: pointer;" :src="liaotian"> -->
              <i class="el-icon-s-comment" style="font-size: 22px; color: #07c160; cursor: pointer"></i>
            </div>
            <div class="user-name">交互</div>
            <div class="support" style="margin-top: -7px">
              <el-dropdown size="small" placement="top-end">
                <img width="24" height="24" style="cursor: pointer" :src="jiqi" />
                <el-dropdown-menu slot="dropdown">
                  <!--  <div>
                    <el-dropdown-item icon="el-icon-tickets" class="clearfix">
                      规则列表
                    </el-dropdown-item>
                  </div> -->
                </el-dropdown-menu>
              </el-dropdown>
            </div>
            <div class="user-name">运维</div>
            <div class="support">
              <el-dropdown size="small" placement="top-end">
                <img width="23" height="23" style="cursor: pointer; margin-top: -3px; margin-left: -5px" :src="keshi" />
                <el-dropdown-menu slot="dropdown">
                  <!-- <div @click="shCityWork">
                    <el-dropdown-item icon="el-icon-s-marketing" class="clearfix">
                      上海城工可视化一版
                    </el-dropdown-item>
                  </div> -->
                  <!-- <div @click="shCityWorkTwo">
                    <el-dropdown-item icon="el-icon-s-marketing" class="clearfix">
                      上海城工可视化
                    </el-dropdown-item>
                  </div> -->
                  <!-- <div @click="jumpdyt">
                    <el-dropdown-item icon="el-icon-s-marketing" class="clearfix">
                      钓鱼台数据可视化
                    </el-dropdown-item>
                  </div> -->
                  <!--  <div @click="jumpFive">
                    <el-dropdown-item icon="el-icon-s-marketing" class="clearfix">
                      南瑞B2产业楼
                    </el-dropdown-item>
                  </div> -->
                  <!-- <div @click="visualization">
                    <el-dropdown-item icon="el-icon-s-marketing" class="clearfix">
                      国传1M04办公室
                    </el-dropdown-item>
                  </div> -->
                  <!-- <div @click="trafficSig">
                    <el-dropdown-item icon="el-icon-s-marketing" class="clearfix">
                      腾讯滨海大厦
                    </el-dropdown-item>
                  </div> -->
                  <!-- <div @click="solarEnergyBigShow">
                    <el-dropdown-item icon="el-icon-s-marketing" class="clearfix">
                      太阳能界面
                    </el-dropdown-item>
                  </div> -->
                  <!-- <div @click="onlineChartTraffic()">
                    <el-dropdown-item icon="el-icon-s-marketing" class="clearfix">
                      信号灯曲线
                    </el-dropdown-item>
                  </div> -->
                  <!-- <div @click="trafficSig()">
                    <el-dropdown-item icon="el-icon-s-marketing" class="clearfix">
                      人体监测
                    </el-dropdown-item>
                  </div> -->
                  <!--  <div @click="cadShowBig()">
                    <el-dropdown-item icon="el-icon-s-marketing" class="clearfix">
                      CAD视图1
                    </el-dropdown-item>
                  </div> -->
                  <!-- <div @click="cadShowBig1()">
                    <el-dropdown-item icon="el-icon-s-marketing" class="clearfix">
                      CAD视图
                    </el-dropdown-item>
                  </div> -->
                  <!-- <div @click="onlineFishe()">
                    <el-dropdown-item icon="el-icon-s-marketing" class="clearfix">
                      光明渔业
                    </el-dropdown-item>
                  </div> -->
                  <!--  <div @click="onlineImportScreen()">
                    <el-dropdown-item class="clearfix">
                      测试大屏
                    </el-dropdown-item>
                  </div> -->
                  <!--  <div @click="meettingOn()">
                    <el-dropdown-item icon="el-icon-s-marketing" class="clearfix">
                      城工试点
                    </el-dropdown-item>
                  </div> -->
                  <!-- <div @click="longxin()">
                    <el-dropdown-item icon="el-icon-s-marketing" class="clearfix">
                      泰豪会议室
                    </el-dropdown-item>
                  </div> -->
                  <!-- <div @click="okService()">
                    <el-dropdown-item class="clearfix">
                      连接服务平台
                    </el-dropdown-item>
                  </div>
                  <div @click="offService()">
                    <el-dropdown-item class="clearfix">
                      断开服务平台
                    </el-dropdown-item>
                  </div> -->
                  <!-- <div @click="officeOn()">
                    <el-dropdown-item class="clearfix">
                      办公室
                    </el-dropdown-item>
                  </div> -->
                </el-dropdown-menu>
              </el-dropdown>
            </div>
            <div class="user-name">视图</div>
            <div class="support">
              <el-dropdown placement="top-end">
                <img width="18" height="18" style="cursor: pointer" :src="lianjie" />
                <el-dropdown-menu slot="dropdown">
                  <div @click="okService()">
                    <el-dropdown-item icon="el-icon-user-solid" class="clearfix">
                      请求远程协助
                    </el-dropdown-item>
                  </div>
                  <div @click="jumpSevice()">
                    <el-dropdown-item icon="el-icon-s-grid" class="clearfix">
                      支持服务平台
                    </el-dropdown-item>
                  </div>
                  <!-- <div @click="servicePlatform()">
                    <el-dropdown-item icon="el-icon-position" class="clearfix">
                      登录服务平台
                    </el-dropdown-item>
                  </div> -->
                  <!-- <div @click="upFileShow = true">
                    <el-dropdown-item icon="el-icon-s-promotion" class="clearfix">
                      上传升级文件
                    </el-dropdown-item>
                  </div> -->
                </el-dropdown-menu>
              </el-dropdown>
            </div>
            <div class="user-name">支持</div>
            <!--  <div class="support">
              <el-dropdown placement="top-end">
                <span class="el-dropdown-link">
                  <img width="18" height="18" style='cursor: pointer;' :src="model">
                </span>
                <el-dropdown-menu slot="dropdown" placement="top-end"> -->
            <!-- <div @click="onlineChartTraffic()">
                    <el-dropdown-item class="clearfix">
                      柱状图展示
                    </el-dropdown-item>
                  </div> -->
            <!-- <div @click="longxin()">
                    <el-dropdown-item class="clearfix">
                      泰豪会议室
                    </el-dropdown-item>
                  </div>
                   <div @click="openBig()">
                    <el-dropdown-item class="clearfix">
                      大屏展示
                    </el-dropdown-item>
                  </div>
                   <div @click="openChu()">
                    <el-dropdown-item class="clearfix">
                      触摸屏界面
                    </el-dropdown-item>
                  </div>  -->
            <!-- <div @click="open()">
                    <el-dropdown-item class="clearfix">
                      门禁管理
                    </el-dropdown-item>
                  </div> -->
            <!-- <div @click="users()">
                    <el-dropdown-item class="clearfix">
                      用户管理
                    </el-dropdown-item>
                  </div> -->
            <!--   <div @click="onlineChartTraffic()">
              <el-dropdown-item class="clearfix">
                信号灯曲线

              </el-dropdown-item>
            </div>
            <div @click="onlineFishe()">
              <el-dropdown-item class="clearfix">
                光明渔业
              </el-dropdown-item>
            </div> -->
            <!-- <div @click="onlineImportScreen()">
                    <el-dropdown-item class="clearfix">
                      中水页面
                    </el-dropdown-item>
                  </div> -->
            <!-- <div @click="meettingOn()">
              <el-dropdown-item class="clearfix">
                北京会议室
              </el-dropdown-item>
            </div> -->
            <!--  <div @click="okService()">
                    <el-dropdown-item class="clearfix">
                      请求远程协助
                    </el-dropdown-item>
                  </div>
                  <div @click="offService()">
                    <el-dropdown-item class="clearfix">
                      断开服务平台
                    </el-dropdown-item>
                  </div> -->
            <!-- <div>
                    <el-dropdown-item icon="el-icon-s-grid" class="clearfix">
                      资产管理
                    </el-dropdown-item>
                  </div>
                  <div>
                    <el-dropdown-item icon="el-icon-lock" class="clearfix">
                      安全管理
                    </el-dropdown-item>
                  </div>
                  <div @click="users()">
                    <el-dropdown-item icon="el-icon-user-solid" class="clearfix">
                      人员管理
                    </el-dropdown-item>
                  </div> -->
            <!--   <div @click="officeOn()">
              <el-dropdown-item class="clearfix">
                办公室
              </el-dropdown-item>
            </div> -->
            <!--  <div @click="ApplyTest()">
                    <el-dropdown-item icon="el-icon-s-grid" class="clearfix">
                      应用管理平台
                    </el-dropdown-item>
                  </div> -->
            <!-- <div @click="createBig()">
                    <el-dropdown-item icon="el-icon-s-grid" class="clearfix">
                      创建可视化页面
                    </el-dropdown-item>
                  </div> -->
            <!-- </el-dropdown-menu>
              </el-dropdown>
            </div> -->
            <!--  <div class="user-name">应用</div> -->
            <div class="support" style="margin-left: 60px" @click="updatePassword">
              <img width="18" height="18" style="cursor: pointer" :src="user" />
            </div>
            <div class="user-name">{{ username }}</div>
            <div class="support">
              <img width="18" height="18" style="cursor: pointer" :src="logoutIcon" @click="logout" />
            </div>
          </div>
        </div>
      </div>
      <!-- 中间内容区域 -->
      <div :style="{ height: middle_height + 'px' }" class="f-row f-full">
        <!-- 左侧菜单树 -->
        <div :style="{ width: tree_width + 'px' }" style="overflow: auto" class="main-tree">
          <side-nav slot="sidebar" :data="navsData" />
        </div>
        <!--中间列表区域-->
        <div :style="{ width: grid_width + 'px' }" class="main-body f-full">
          <router-view :key="$route.path + $route.query.t" />
        </div>
      </div>
      <!-- 底部区域 -->
      <div class="toggle-bar f-row f-full">
        <div style="
            width: 100%;
            height: 100%;
            position: absolute;
            padding-left: 150px;
            overflow: hidden;
          ">
          <!--  事件搜索 -->
          <div v-if="eventShow" style="
              display: flex;
              align-items: center;
              justify-content: space-between;
              padding-right: 30px;
            ">
            <div style="
                width: 100%;
                height: 35px;
                display: flex;
                align-items: center;
                justify-content: right;
                box-sizing: border-box;
              ">
              <div class="inp-box" style="width: 600px">
                <el-input v-model="serachDataList.queryFields.objectName" placeholder="请输入对象"></el-input>
              </div>

              <div class="time-chart-box">
                <el-date-picker v-model="serachDataList.startTime" type="date" value-format="timestamp"
                  placeholder="开始时间">
                </el-date-picker>
              </div>

              <div class="time-chart-box">
                <el-date-picker v-model="serachDataList.endTime" type="date" value-format="timestamp"
                  placeholder="结束时间">
                </el-date-picker>
              </div>
              <div class="inp-box">
                <el-input v-model="serachDataList.queryFields.userName" placeholder="请输入操作用户"></el-input>
              </div>
              <div class="inp-box">
                <el-input v-model="serachDataList.queryFields.description" placeholder="请输入事件描述"></el-input>
              </div>
              <div class="time-chart-box" style="width: 100px">
                <el-select v-model="serachDataList.queryFields.points" placeholder="报警状态">
                  <el-option v-for="item in statePolice" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
              </div>

              <div class="time-chart-box" style="width: 100px">
                <el-select v-model="serachDataList.queryFields.operateType" placeholder="操作类型">
                  <el-option v-for="item in stateSet" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
              </div>

              <div>
                <gs-button type="primary" icon="el-icon-search" size="mini" @click="searchEvent">搜索</gs-button>
              </div>
            </div>
            <div class="search-box"></div>
          </div>
          <!-- 报警搜索 -->
          <div v-if="alarmShow" style="
              display: flex;
              align-items: center;
              justify-content: space-between;
              padding-right: 30px;
            ">
            <div style="
                width: 100%;
                height: 35px;
                display: flex;
                align-items: center;
                justify-content: right;
                box-sizing: border-box;
              ">
              <div class="inp-box" style="width: 600px">
                <el-input v-model="seachAlarmList.queryFields.objectName" placeholder="请输入报警对象"></el-input>
              </div>

              <div class="time-chart-box">
                <el-date-picker v-model="seachAlarmList.startTime" type="date" value-format="timestamp"
                  placeholder="开始时间">
                </el-date-picker>
              </div>

              <div class="time-chart-box">
                <el-date-picker v-model="seachAlarmList.endTime" type="date" value-format="timestamp"
                  placeholder="结束时间">
                </el-date-picker>
              </div>

              <div class="inp-box">
                <el-input v-model="seachAlarmList.queryFields.userName" placeholder="请输入操作用户"></el-input>
              </div>

              <div class="inp-box">
                <el-input v-model="seachAlarmList.queryFields.description" placeholder="请输入报警描述"></el-input>
              </div>

              <div class="time-chart-box" style="width: 100px">
                <el-select v-model="seachAlarmList.queryFields.state" placeholder="报警状态">
                  <el-option v-for="item in statePolice1" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
              </div>

              <!-- <div class="time-chart-box" style="width: 100px;">
                <el-select v-model="serachDataList.queryFields.operateType" placeholder="操作类型">
                  <el-option v-for="item in stateSet" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
              </div> -->

              <div>
                <gs-button type="primary" icon="el-icon-search" size="mini" @click="alarmEvent">搜索</gs-button>
              </div>
            </div>
            <div class="search-box"></div>
          </div>
        </div>
        <span class="main-toggle fa fa-bars" @click="bottom_toggle()">
          <div id="report" style="
              width: 15px;
              height: 16px;
              position: relative;
              top: 8px;
              background-image: url('../../static/img/icon/向上.png');
              background-size: 100% 100%;
              background-repeat: no-repeat;
            " />
        </span>
        <div style="padding-top: 3px; display: flex">
          <span v-if="alarmShow" class="textStyle">报警：</span>
          <span v-if="eventShow" class="textStyle">事件：</span>
          <span v-if="searchShow" class="textStyle">在线用户</span>
          <span v-if="customShow" class="textStyle">自定义报警</span>
          <span v-if="serverShow" class="textStyle">服务器报警</span>
          <div style="
              width: 26px;
              height: 26px;
              background-image: url('../../static/img/icon/jing.gif');
              background-size: 100% 100%;
            " v-if="alarmShow"></div>
          <span v-if="alarmShow" class="textStyle2">{{ alarmNum }}</span>
          <span v-if="eventShow" class="textStyle2">{{ eventNum }}</span>

          <span v-if="customShow" class="textStyle2">{{ customNum }}</span>
          <!-- <span class="textStyle3">/345</span> 暂时只显示总量-->
        </div>
      </div>
      <!--报警/事件/搜索区域-->
      <div :style="{ height: bottom_height + 'px' }" class="f-row f-full" v-show="footerShow">
        <Tabs ref="tabs" :header-height="26" :narrow="true" :selected-index="selectedIndex" tab-position="bottom"
          @tabSelect="tabSelect">
          <TabPanel :border="false" title="通讯报警" body-cls="f-column">
            <alarm-list v-if="alarmShow" class="f-full" ref="alarm" />
          </TabPanel>
          <TabPanel :border="false" title="自定义报警" body-cls="f-column">
            <alarmListOne v-if="customShow" class="f-full" />
          </TabPanel>

          <TabPanel :border="false" title="操作日志" body-cls="f-column">
            <event-list v-if="eventShow" class="f-full" ref="events" />
          </TabPanel>
          <TabPanel :border="false" title="在线用户" body-cls="f-column">
            <users-list v-if="usersShow" class="f-full" />
          </TabPanel>
          <TabPanel :border="false" title="服务器报警" body-cls="f-column">
            <server-list v-if="serverShow" class="f-full" />
          </TabPanel>
          <TabPanel v-if="searchPanelShow" :border="false" title="搜索" body-cls="f-column">
            <search-list class="f-full" />
          </TabPanel>
        </Tabs>
      </div>
    </div>
    <el-dialog title="场景视图" :visible.sync="dialogVisible" width="50%" :before-close="handleClose">
      <div style="
          width: 100%;
          height: 500px;
          background-color: white;
          padding: 15px 15px;
        ">
        <el-row :gutter="10" type="flex" style="min-height: 40%; top: 20%">
          <el-col :span="8">
            <div @click="suzhouhuiyishi" class="shitu-tellhow"
              style="background-image: url('/static/img/mould/huiyi.png')"></div>
          </el-col>
          <el-col :span="8">
            <div @click="lengdongzhan" class="shitu-tellhow"
              style="background-image: url('/static/img/mould/lengdong.png')"></div>
          </el-col>
          <el-col :span="8">
            <div @click="changfang" class="shitu-tellhow"
              style="background-image: url('/static/img/mould/shengchan.png')"></div>
          </el-col>
        </el-row>
        <el-row :gutter="10" type="flex" style="min-height: 2%; top: 23%">
          <el-col :span="8">
            <div @click="suzhouhuiyishi" class="shitu-tellhow">
              <span>会议室</span>
            </div>
          </el-col>
          <el-col :span="8">
            <div @click="lengdongzhan" class="shitu-tellhow">
              <span>冷冻站</span>
            </div>
          </el-col>
          <el-col :span="8">
            <div @click="changfang" class="shitu-tellhow">
              <span>厂房</span>
            </div>
          </el-col>
        </el-row>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="mini" @click="dialogVisible = false">取 消</el-button>
        <el-button size="mini" type="primary" @click="dialogVisible = false">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog title="请复制该token" :visible.sync="dialogServiceJupm" width="30%" :before-close="dialogServiceJupmClose">
      <span>token： {{ getToken }}</span>
      <span slot="footer" class="dialog-footer">
        <el-button size="mini" @click="dialogServiceJupm = false">取 消</el-button>
        <el-button size="mini" type="primary" @click="jumpSevice">跳 转</el-button>
      </span>
    </el-dialog>
    <el-dialog title="上传升级文件" :visible.sync="upFileShow" width="30%" :before-close="handleCloseFileShow">
      <span>这是一段信息</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="upFileShow = false">取 消</el-button>
        <el-button type="primary" @click="upFileShow = false">确 定</el-button>
      </span>
    </el-dialog>
    <!--  <el-dialog title="模板选择" :visible.sync="createBigShow" width="50%" :before-close="handleClosecreateBigShow">
      <div style="width: 100%;font-size: 15px;margin-bottom: 10px;"><span>布局选择</span></div>
      <el-radio v-model="radio" label="1">模板1
        <div style="width: 250px;height: 150px;">
          <img src="../assets/diy/001.png" style="width: 250px;height: 150px;">
        </div>
      </el-radio>
      <el-radio v-model="radio" label="2">模板2
        <div style="width: 250px;height: 150px;">
          <img src="../assets/diy/002.png" style="width: 250px;height: 150px;">
        </div>
      </el-radio>
      <el-radio v-model="radio" label="3">模板3
        <div style="width: 250px;height: 150px;">
          <img src="../assets/diy/003.png" style="width: 250px;height: 150px;">
        </div>
      </el-radio>
      <div style="width: 100%;font-size: 15px;margin-bottom: 10px;"><span>背景图选择/背景图连接</span></div>
      <el-radio v-model="radiobg" label="1">背景1
        <div style="width: 250px;height: 150px;">
          <img src="../assets/diy/bj001.png" style="width: 250px;height: 150px;">
        </div>
      </el-radio>
      <el-radio v-model="radiobg" label="2">背景2
        <div style="width: 250px;height: 150px;">
          <img src="../assets/diy/bj002.png" style="width: 250px;height: 150px;">
        </div>
      </el-radio>
      <el-radio v-model="radiobg" label="3">背景3
        <div style="width: 250px;height: 150px;">
          <img src="../assets/diy/bj003.png" style="width: 250px;height: 150px;">
        </div>
      </el-radio>
      <div style="width: 100%;">
        <el-input v-model="bjUrl" placeholder="填写背景图片的URL地址" style="width: 89%;"></el-input>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="createBigShow = false" size="mini">取 消</el-button>
        <el-button type="primary" @click="createBigShow = false" size="mini">确 定</el-button>
      </span>
    </el-dialog> -->

    <transition name="bounceone" type="transition">
      <div class="robot-box" v-if="robotShow"></div>
    </transition>
    <gs-modal v-model="searchDialogVisible" class="my-test-class search-sn-dialog" title="搜索" width="350px"
      @confirm="queryBySn">
      <gs-form ref="queryBySnForm" class="form" label-width="50px" label-position="left" gap="small">
        <gs-form-item label="sn:" prop="name" class="form-item-name">
          <gs-input v-model="queryBySnForm.sn" type="text" />
        </gs-form-item>
        <gs-form-item label="din:" prop="name" class="form-item-name">
          <gs-input v-model="queryBySnForm.din" type="text" />
        </gs-form-item>
      </gs-form>
    </gs-modal>
    <gs-modal v-model="searchLookVisible" class="my-test-class look-din-dialog" title="搜索">
      <div v-if="searchSnData.length">
        <div v-for="item in searchSnData" :key="item" style="padding: 5px 0">
          {{ item }}
        </div>
      </div>
      <div v-else style="text-align: center">暂无数据</div>
      <span slot="footer" class="dialog-footer"></span>
    </gs-modal>
    <!-- 修改密码弹窗 -->
    <gs-modal v-model="changePwdVisible" class="my-test-class" title="修改密码" width="400px"
      :before-close="handleChangePwdClose" @close="handleChangePwdClose" @confirm="handleChangePwdConfirm">
      <el-form :model="changePwdForm" label-width="100px">
        <el-form-item label="当前密码" required>
          <el-input v-model="changePwdForm.currentPassword" type="password" placeholder="请输入当前密码"
            show-password></el-input>
        </el-form-item>
        <el-form-item label="新密码" required>
          <el-input v-model="changePwdForm.newPassword" type="password" placeholder="请输入新密码" show-password></el-input>
        </el-form-item>
        <el-form-item label="确认新密码" required>
          <el-input v-model="changePwdForm.confirmPassword" type="password" placeholder="请再次输入新密码"
            show-password></el-input>
        </el-form-item>
      </el-form>
    </gs-modal>
  </div>
</template>

<script>
import welinkLogin from "../assets/logOne.png";
import toggle from "../assets/toggle.png";
import logoutIcon from "../assets/退出.png";
import user from "../assets/user.png";
import lianjie from "../assets/服务中心.png";
import police from "../assets/实时报警.png";
import jiqi from "../assets/001.png";
import model from "../assets/服务.png";
import keshi from "../assets/keshihua.png";
import liaotian from "../assets/liaotian.png";
import SideNav from "../components/left-side/side-nav";
import sideTree from "../components/left-side/sideTree";
import alarmList from "../components/alarm/alarmList";
import serverList from "../components/alarm/serverList";
import alarmListOne from "../components/alarm/alarmList1";
import eventList from "../components/alarm/eventList";
import usersList from "../components/alarm/usersList";
import searchList from "../components/alarm/searchList";
import orderSelect from "../components/orderSelect/orderSelect";
import authorityService from "../service/authorityService.js";
import service from "../service/leftService.js";
import alarmService from "../service/alarmService.js";
import { mapState, mapMutations } from "vuex";
import { disconnect } from "../config/webScoket";
import moment from "moment";
export default {
  components: {
    SideNav,
    sideTree,
    alarmList,
    serverList,
    eventList,
    searchList,
    usersList,
    orderSelect,
    alarmListOne,
  },
  data() {
    return {
      bjUrl: "",
      radio: "1",
      radiobg: "1",
      createBigShow: false,
      robotShow: false,
      // 修改密码相关
      changePwdVisible: false,
      changePwdForm: {
        currentPassword: "",
        newPassword: "",
        confirmPassword: "",
      },
      serachDataList: {
        pageSize: 50, // 每页显示条数
        pageNum: 1, // 页数
        startTime: null, // 开始时间
        endTime: null, // 结束时间
        sortField: "timestamp", // 排序字段 ，固定的，只有这一个，不可为空
        sortOrder: "desc", // 排序类型（正序还是倒序） ，不可为空
        queryFields: {
          userName: "", // 操作用户
          objectType: "", // 对象类型
          objectName: "", // 对象
          operateType: "", // 操作类型
          points: "", // 报警状态
          description: "", // 事件描述
        },
      },
      seachAlarmList: {
        pageSize: 50, // 每页显示条数
        pageNum: 1, // 页数
        startTime: null, // 开始时间
        endTime: null, // 结束时间
        sortField: "lastChange",
        sortOrder: "desc",
        queryFields: {
          userName: "", // 操作用户
          description: "", // 报警描述
          objectName: "", // 报警对象
          state: "", // 报警状态
        },
      },
      searchData: "",
      customNum: "",
      customShow: false,
      upFileShow: false,
      serverShow: false,
      getToken: "1234555555casc84a6s8c4asc46_1028",
      dialogServiceJupm: false,
      tabs_show: false,
      wisdowShow: false,
      dialogVisible: false,
      vueid: "tellhowid",
      tellhow: false, // 泰豪系统显示
      tellhowIndex: true, // 泰豪首页显示
      tellhowSuMap: false, // 泰豪苏州显示
      welinkLogin,
      toggle,
      logoutIcon,
      keshi,
      user,
      lianjie,
      liaotian,
      police,
      jiqi,
      model,
      navsData: [
        {
          id: 1,
          name: "首页",
          // icon: 'user',
          path: "/home",
          disabled: false,
        },
        {
          id: 2,
          name: "一级导航",
          // icon: 'user',
          children: [
            {
              id: 3,
              name: "二级导航",
              path: "/demo2",
              disabled: false,
            },
          ],
        },
      ],
      isFixed: true,
      footerShow: false,
      activeName: "first",
      changeStatusIcon: "double-up",
      options: [
        {
          value: "logout",
          label: "登出",
        },
      ],
      options1: [
        {
          value: "logout",
          label: "暂无数据",
        },
      ],
      statePolice: [
        {
          value: "",
          label: "无报警",
        },
        {
          value: "Normal",
          label: "恢复",
        },
        {
          value: "Alarm",
          label: "报警",
        },
      ],
      statePolice1: [
        {
          value: "",
          label: "无",
        },
        {
          value: "Normal",
          label: "恢复",
        },
        {
          value: "Alarm",
          label: "报警",
        },
      ],
      stateSet: [
        {
          value: "",
          label: "无操作",
        },
        {
          value: "UPDATE",
          label: "修改操作",
        },
        {
          value: "CREATE",
          label: "创建操作",
        },
        {
          value: "DELETE",
          label: "删除操作",
        },
      ],
      tree_width: 350, // 左侧树宽度
      grid_width: `${document.documentElement.clientWidth - 350}`, // 右侧列表宽度
      middle_height: `${document.documentElement.clientHeight - 90}`, // 中间区域高度
      bottom_height: 0, // 底部区域高度
      grid_title: "文件夹",
      tree_collapsed: false,
      alarm_collapsed: false,
      tree_data: null,
      grid_data: null,
      alarm_data: null,
      event_data: null,
      selectedNodeType: "root",
      selectedNode: null,
      selectedIndex: 0,
      alarmShow: true,
      eventShow: false,
      searchShow: false,
      searchPanelShow: false,
      timerIndex: null,
      warningNumber: 0,
      warningShow: false,
      params: {
        pageSize: 50,
        pageNum: 1,
        sortField: "lastChange",
        sortOrder: "desc",
      },
      timer: null,
      hours: "",
      minutes: "",
      seconds: "",
      time1: moment(),
      defaultTime: moment(),
      searchDialogVisible: false,
      queryBySnForm: {
        sn: "",
        din: "",
      },
      searchLookVisible: false,
      searchSnData: [],
    };
  },
  created() {
    this.timer = setInterval(() => {
      var myDate = new Date();
      this.hours = myDate.getHours();
      this.minutes = myDate.getMinutes();
      this.seconds = myDate.getSeconds();
    }, 1000);
  },
  computed: {
    username() {
      let userInfo = localStorage.getItem("userInfo");
      if (userInfo !== null) {
        let userObj = JSON.parse(userInfo);
        return userObj.username ? userObj.username : "";
      }
      return "";
    },
    ...mapState({
      alarmNum: "alarmNum",
      eventNum: "eventNum",
      usersNum: "usersNum",
      searchResult: "searchResult",
      objectInfo: "objectInfo",
      searchParams: "searchParams",
    }),
  },
  watch: {
    searchResult() {
      if (!this.alarm_collapsed) {
        this.bottom_toggle();
      }
      if (!this.searchPanelShow) {
        this.searchPanelShow = true;
      }
      if (this.selectedIndex !== 2) {
        setTimeout(() => {
          this.$refs.tabs.select(2);
        }, 0);
      }
    },
    objectInfo: {
      handler() {
        if (this.alarm_collapsed && this.searchPanelShow) {
          setTimeout(() => {
            service
              .search(this.searchParams)
              .then((res) => {
                this.$store.state.searchResult = res;
              })
              .catch((err) => {
                console.log(err);
                // this.$Message.error(err.message)
              });
          }, 100);
        }
      },
      deep: true,
    },
  },
  methods: {
    ...mapMutations({
      //记事本
      noteBookShow: "NOTE_BOOK_SHOW",
      topicShow: "TOPIC_SHOW",
      doorShow: "DOOR_SHOW",
      usersShow: "USERS_SHOW",
    }),
    messageOk() {
      this.$message({
        showClose: true,
        message: "操作通知：XXX用户操作了XXX数据对数据进行修改。",
        type: "warning",
        duration: 4000,
      });
    },
    handleClosecreateBigShow() {
      this.createBigShow = false;
    },
    handleCloseFileShow() {
      this.upFileShow = false;
    },
    dialogServiceJupmClose() {
      this.dialogServiceJupm = false;
    },
    // 上海城工界面
    shCityWork() {
      let url = this.$router.resolve({
        name: `screwShow`,
        query: {},
      });
      window.open(url.href, "_blank");
    },
    // 上海城工界面2
    shCityWorkTwo() {
      let url = this.$router.resolve({
        name: `screwShowTwo`,
        query: {},
      });
      window.open(url.href, "_blank");
    },
    // 国传1M界面可视化
    visualization() {
      let url = this.$router.resolve({
        name: `visuaShow`,
        query: {},
      });
      window.open(url.href, "_blank");
    },
    // 交通信号灯界面
    trafficSig() {
      this.$router.push({ name: "TrafficSignal" });
    },
    // 太阳能界面
    solarEnergyBigShow() {
      this.$router.push({ name: "solarEnergyBigShow" });
    },
    // 光明渔业
    onlineFishe() {
      this.$router.push({ name: "Fishe" });
    },
    // 切换到产品视图页面
    switchProduct() {
      // this.$router.push({name: 'productIntroduction'})
      window.open("http://112.80.54.214/", "_blank");
    },
    // 上海城工界面
    meettingOn() {
      this.$router.push({ name: "cgShow" });
    },
    openBig() {
      window.open("../../static/html/ThbigShow.html", "_blank");
    },
    openChu() {
      window.open("../../static/html/ThTouchScreen.html", "_blank");
    },
    /*  officeOn() {
       window.open('../../static/html/index.html', '_blank')
     }, */
    // 跳转交通数据曲线
    onlineChartTraffic() {
      this.$router.push({ name: "onlineChartTraffic" });
      /* this.$router.push({ name: 'energyBarShow' }) */
    },
    // 跳转CAD页面
    cadShow() {
      //this.$router.push({ name: 'onlineChartTraffic' })
      this.$router.push({ name: "cadShow" });
    },
    cadShowBig() {
      this.$router.push({ name: "cadBigShow" });
    },
    jumpFive() {
      // this.$router.push({ name: 'NARI' })
      let url = this.$router.resolve({
        name: `NariMain`,
        query: {},
      });
      window.open(url.href, "_blank");
    },
    jumpdyt() {
      let url = this.$router.resolve({
        name: `fishingShow`,
        query: {},
      });
      window.open(url.href, "_blank");
    },
    cadShowBig1() {
      this.$router.push({ name: "GcBigShow" });
    },
    // 时间同步操作
    timeSynchronization() {
      service
        .setTime()
        .then((res) => {
          this.$Message.success("同步成功");
        })
        .catch((err) => {
          this.$Message.error("同步失败");
        });
    },
    topic() {
      this.topicShow();
    },
    modelShow() {
      this.dialogVisible = true;
    },
    handleClose() {
      this.dialogVisible = false;
    },
    // 返回首页
    gobackIndex() {
      this.tellhowIndex = true;
      this.tellhowSuMap = false;
      this.tellhow = false;
    },
    // 苏州会议室
    suzhouhuiyishi() {
      this.tellhow = true;
      let node = {
        attribute: {
          modelId: 103,
          objectSeries: [],
        },
        children: null,
        description: "大屏显示",
        fullId: null,
        fullName:
          "微瓴平台-饱和数据测试-苏州实验室服务器-服务器接入/处理数据能力测试-苏州实验室测试组-苏州会议室-会议室场景",
        icon: "../../../static/img/aim-icon/图形化界面.png",
        id: "5ee8305eb28676665ca603af",
        label: [],
        name: "会议室场景",
        parentId: "5e82fe6058d687346bd4d8b6",
        secondName: null,
        time: null,
        timeStamp: 1612141658,
        type: "graphic",
        unfold: true,
        unit: null,
        value: null,
      };
      this.$store.state.leftClickNode = new Date().getTime();
      this.$store.state.nodeTree = node;
      this.$router.push({
        name: "graphiCallyShow",
        query: { facility: [], id: "5e82fe6058d687346bd4d8b6", t: Date.now() },
      });
    },
    // 冷冻站
    lengdongzhan() {
      this.tellhow = true;
      let node = {
        attribute: {
          modelId: 112,
          objectSeries: [],
        },
        children: null,
        description: "冷冻站",
        fullId: null,
        fullName:
          "微瓴平台-饱和数据测试-苏州实验室服务器-服务器接入/处理数据能力测试-苏州实验室测试组-冷冻站",
        icon: "../../../static/img/aim-icon/图形化界面.png",
        id: "5fe40785de1a17611e89c6c3",
        label: [],
        name: "冷冻站",
        parentId: "5e4f47f3a94a510f70350ce6",
        secondName: null,
        time: null,
        timeStamp: 1608779653,
        type: "graphic",
        unfold: true,
        unit: null,
        value: null,
      };
      this.$store.state.leftClickNode = new Date().getTime();
      this.$store.state.nodeTree = node;
      this.$router.push({
        name: "graphiCallyShow",
        query: { facility: [], id: "5e4f47f3a94a510f70350ce6", t: Date.now() },
      });
    },
    // 厂房
    changfang() {
      this.tellhow = true;
      let node = {
        attribute: {
          modelId: 107,
          objectSeries: [],
        },
        children: null,
        description: "厂房视图",
        fullId: null,
        fullName:
          "微瓴平台-饱和数据测试-苏州实验室服务器-服务器接入/处理数据能力测试-生产车间场景",
        icon: "../../../static/img/aim-icon/图形化界面.png",
        id: "5f4861c123471510c4c9cbc6",
        label: [],
        name: "生产车间场景",
        parentId: "5e4f4218a94a510f70350ce4",
        secondName: null,
        time: null,
        timeStamp: 1612138139,
        type: "graphic",
        unfold: false,
        unit: null,
        value: null,
      };
      this.$store.state.leftClickNode = new Date().getTime();
      this.$store.state.nodeTree = node;
      this.$router.push({
        name: "graphiCallyShow",
        query: { facility: [], id: "5e4f47f3a94a510f70350ce6", t: Date.now() },
      });
    },
    // 泰豪系统
    tellHow() {
      this.tellhow = true;
    },
    // 智慧灯杆页面
    wisdow() {
      this.wisdowShow = true;
    },
    // 智慧灯杆页面关闭
    wisdowBack() {
      this.wisdowShow = false;
    },
    // 点击苏州的城市
    suzhouMap() {
      this.tellhowIndex = false; // 泰豪首页显示
      this.tellhowSuMap = true;
    },
    models() {
      this.$router.push({ name: "modelAdministrate" });
    },
    // 龙芯
    longxin() {
      this.$router.push({ name: "lxbigshow" });
    },
    // 测试大屏
    onlineImportScreen() {
      this.$router.push({ name: "ImportScreen" });
    },
    // 修改密码
    updatePassword() {
      this.changePwdForm = {
        currentPassword: "",
        newPassword: "",
        confirmPassword: "",
      };
      this.changePwdVisible = true;
    },
    handleChangePwdClose() {
      this.changePwdVisible = false;
    },
    handleChangePwdConfirm() {
      const { currentPassword, newPassword, confirmPassword } =
        this.changePwdForm;
      // 校验必填
      if (!currentPassword) {
        this.$message.error("请输入当前密码");
        return;
      }
      if (!newPassword) {
        this.$message.error("请输入新密码");
        return;
      }
      if (!confirmPassword) {
        this.$message.error("请确认新密码");
        return;
      }
      // 校验两次密码是否一致
      if (newPassword !== confirmPassword) {
        this.$message.error("两次输入的新密码不一致");
        return;
      }
      // 获取当前用户ID
      const userInfo = JSON.parse(localStorage.getItem("userInfo") || "{}");
      const userId = userInfo.userId;
      if (!userId) {
        this.$message.error("获取用户信息失败，请重新登录");
        return;
      }
      // 调用修改密码接口
      authorityService
        .updatePassword(userId, currentPassword, newPassword)
        .then((res) => {
          this.$message.success("密码修改成功");
          this.changePwdVisible = false;
        })
        .catch((err) => {
          console.log(err);
          this.$message.error(err.message || "密码修改失败");
        });
    },
    logout() {
      this.$store.state.loginStatus = false;
      authorityService
        .logout()
        .then((res) => {
          localStorage.removeItem("Authorization");
          localStorage.removeItem("userInfo");
          this.$store.state.userArray.length = 0;
          this.$router.push({ name: "login" });
          disconnect();
          // location.reload()
        })
        .catch((err) => {
          console.log(err);
          // this.$Message.error(err.message)
        });
    },
    returnIndex() {
      /*this.$router.push({name: 'homePage'})*/
    },
    kong() { },
    tabSelect(panel) {
      if (panel.title === "通讯报警") {
        this.customShow = false;
        this.alarmShow = true;
        this.serverShow = false;
        this.eventShow = false;
        this.searchShow = false;
        this.$refs.tabs.select(0);
        this.selectedIndex = 0;
      } else if (panel.title === "操作日志") {
        this.customShow = false;
        this.alarmShow = false;
        this.eventShow = true;
        this.searchShow = false;
        this.serverShow = false;
        this.$refs.tabs.select(2);
        this.selectedIndex = 2;
      } else if (panel.title === "自定义报警") {
        this.customShow = true;
        this.alarmShow = false;
        this.eventShow = false;
        this.serverShow = false;
        this.searchShow = false;
        this.$refs.tabs.select(1);
        this.selectedIndex = 1;
        return false;
      } else if (panel.title === "服务器报警") {
        this.customShow = false;
        this.alarmShow = false;
        this.eventShow = false;
        this.serverShow = true;
        this.searchShow = false;
        this.$refs.tabs.select(4);
        this.selectedIndex = 4;
        return false;
      } else {
        this.alarmShow = false;
        this.eventShow = false;
        this.serverShow = false;
        //this.usersShow = false
        this.searchShow = true;
        this.$refs.tabs.select(3);
        this.selectedIndex = 3;
      }
    },
    left_toggle() {
      this.tree_collapsed = !this.tree_collapsed;
      this.tree_width = this.tree_collapsed ? 0 : 350;
      this.grid_width = this.tree_collapsed
        ? document.documentElement.clientWidth - 5
        : document.documentElement.clientWidth - 350;
    },
    bottom_toggle(winChange = false) {
      if (winChange) {
        if (this.footerShow) {
          let a = document.getElementById("report");
          a.style.backgroundImage = "url(../../static/img/icon/向上.png)";
        } else {
          return;
        }
      } else {
        if (this.footerShow) {
          let a = document.getElementById("report");
          a.style.backgroundImage = "url(../../static/img/icon/向上.png)";
        } else {
          let a = document.getElementById("report");
          a.style.backgroundImage = "url(../../static/img/icon/向下.png)";
        }
      }
      this.alarm_collapsed = !this.alarm_collapsed;
      this.$store.state.toggle = this.alarm_collapsed;
      this.footerShow = !this.footerShow;
      this.bottom_height = this.alarm_collapsed
        ? (document.documentElement.clientHeight - 100) * 0.5 - 2
        : 0;
      this.middle_height = this.alarm_collapsed
        ? (document.documentElement.clientHeight - 100) * 0.5
        : document.documentElement.clientHeight - 90;
    },
    open() {
      this.doorShow();
    },
    users() {
      this.$router.push({ name: "userManage" });
    },
    servicePlatform() {
      service.serviceLogin().then((res) => {
        // alert(res)
      });
      this.dialogServiceJupm = true;
      //window.open('https://www.xiaowu-iot.com/dist/#/login', '_blank')
    },
    // 连接服务平台
    okService() {
      service.serviceLink().then((res) => {
        this.$Message.success("连接成功");
      });
    },
    // 断开服务平台
    offService() {
      service.serviceUnLink().then((res) => {
        this.$Message.success("已断开连接");
      });
    },
    // 点击跳转
    jumpSevice() {
      window.open("https://www.xiaowu-iot.com/dist/#/login", "_blank");
    },
    ApplyTest() {
      window.open("https://uu-iot.com/auth/#/login", "_blank");
    },
    // 条件搜索
    searchEvent() {
      this.$refs.events.searchList(this.serachDataList);
    },
    // 报警条件搜索
    alarmEvent() {
      this.$refs.alarm.alarmList(this.seachAlarmList);
    },
    // 创建可视化界面
    createBig() {
      this.createBigShow = true;
    },
    updateHeight() {
      this.bottom_toggle(true);
      this.middle_height = document.documentElement.clientHeight - 90;
    },
    searchSnClick() {
      this.queryBySnForm.sn = "";
      this.queryBySnForm.din = "";
      this.searchDialogVisible = true;
    },
    queryBySn() {
      this.searchSnData = [];
      service
        .queryBySn(this.queryBySnForm.sn, this.queryBySnForm.din)
        .then((res) => {
          console.log(res);
          this.searchLookVisible = true;
          this.searchSnData = res;
        });
    },
  },
  mounted() {
    /* window.onload = clock;
    function clock() {
      var today = new Date(),//当前时间
        h = today.getHours(),
        m = today.getMinutes(),
        s = today.getSeconds();
      var stopTime = new Date("Mar 18 2020 13:10:00"),//结束时间
        stopH = stopTime.getHours(),
        stopM = stopTime.getMinutes(),
        stopS = stopTime.getSeconds();
      var shenyu = stopTime.getTime() - today.getTime(),//倒计时毫秒数
        shengyuD = parseInt(shenyu / (60 * 60 * 24 * 1000)),//转换为天
        D = parseInt(shenyu) - parseInt(shengyuD * 60 * 60 * 24 * 1000),//除去天的毫秒数
        shengyuH = parseInt(D / (60 * 60 * 1000)),//除去天的毫秒数转换成小时
        H = D - shengyuH * 60 * 60 * 1000,//除去天、小时的毫秒数
        shengyuM = parseInt(H / (60 * 1000)),//除去天的毫秒数转换成分钟
        M = H - shengyuM * 60 * 1000;//除去天、小时、分的毫秒数
      let S = parseInt((shenyu - shengyuD * 60 * 60 * 24 * 1000 - shengyuH * 60 * 60 * 1000 - shengyuM * 60 * 1000) / 1000)//除去天、小时、分的毫秒数转化为秒
      document.getElementById("div").innerHTML = (shengyuD + "天" + shengyuH + "小时" + shengyuM + "分" + S + "秒" + "<br>");
      // setTimeout("clock()",500);
      setTimeout(clock, 500);
    }
    this.$nextTick(function () {
      alarmService.getAlarmList(this.params).then(res => {
        for (let i = 0; i < res.data.length; i++) {
          document.getElementById("vas").innerHTML = "123"
        }
      }).catch(err => {
        console.info(err.message)
      })
    }) */
    // 监听窗口变化
    window.addEventListener("resize", this.updateHeight);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.updateHeight);
  },
};
</script>

<style scoped>
.look-din-dialog /deep/ .gs-modal-wrap {
  width: auto !important;
  max-width: 1300px !important;
}

.look-din-dialog /deep/ .gs-modal-content {
  width: fit-content;
  margin: 0 auto;
}

.search-sn-dialog /deep/ .gs-modal-wrap {
  min-width: 350px;
}

.search-sn-dialog /deep/ .gs-modal-content {
  min-width: 350px;
}

.bounceone-enter-from,
.bounceone-leave-to {
  opacity: 0;
}

.bounceone-enter-active,
.bounceone-leave-active {
  transition: opacity 1s ease;
}

.bounceone-enter-active {
  animation: animate 1s ease;
}

.bounceone-leave-active {
  animation: animate 1s ease reverse;
}

@keyframes animate {
  from {
    height: 0px;
    bottom: 37px;
  }

  to {
    height: 88.8%;
    bottom: 37px;
  }
}

.robot-box {
  position: absolute;
  z-index: 999;
  width: 350px;
  height: 88.8%;
  bottom: 37px;
  right: 0;
  background: rgba(0, 0, 0, 0.25);
  backdrop-filter: blur(5px);
  -webkit-backdrop-filter: blur(5px);
}

.time-chart-box {
  height: 22px;
  margin-right: 20px;
}

.time-chart-box>>>.el-input--suffix .el-input__inner {
  border: 1px solid #848484 !important;
  color: #cdcdcd;
  height: 22px;
  font-size: 10px;
}

.time-chart-box>>>.el-date-editor.el-input,
.el-date-editor.el-input__inner {
  width: 177px;
}

.time-chart-box>>>.el-input__icon {
  line-height: 22px;
}

.time-chart-box>>>.el-picker-panel {
  background: #535353 !important;
}

.inp-box {
  width: 120px;
  margin-right: 20px;
}

.inp-box>>>.el-input__inner {
  height: 22px !important;
  font-size: 10px !important;
  border: 1px solid #8f8c8c !important;
  color: #cdcdcd !important;
}

.support {
  margin-left: 5px;
  width: 18px;
  height: 18px;
}

.shitu-tellhow {
  width: 100%;
  height: 100%;
  background-size: 100% 100%;
  text-align: center;
  cursor: pointer;
  font-size: 2vh;
}

.el-dropdown-menu {
  background-color: #525659 !important;
  border: 1px solid #2a2b2b !important;
}

.el-dropdown-menu__item {
  color: #fff !important;
  line-height: 25px;
  border-bottom: 1px solid rgb(125, 123, 123);
  font-size: 11px;
}

.el-popper[x-placement^="bottom"] .popper__arrow:after {
  border-bottom-color: #525659 !important;
  background-color: #525659 !important;
}

.el-popper[x-placement^="bottom"] .popper__arrow {
  border-bottom-color: #525659 !important;
  background-color: #525659 !important;
}

.el-dropdown-menu__item:focus,
.el-dropdown-menu__item:not(.is-disabled):hover {
  color: #f9fafa !important;
  background-color: #868686 !important;
}

.tellhowBt>>>.el-button {
  background-color: transparent;
  border: 1px solid transparent;
}

.main-container {
  background-color: rgba(66, 70, 73, 0.86);
  height: 100%;
}

html,
body {
  margin: 0;
  padding: 0;
  font-family: 微软雅黑, "Microsoft YaHei", "Avenir", Helvetica, Arial,
    sans-serif;
}

.header-right {
  float: right;
  padding-right: 20px;
  color: rgb(250, 248, 248);
}

.user-name {
  margin: 0 20px 0 10px;
  line-height: 40px;
  font-size: 10px;
  cursor: pointer;
}

.header-user-con {
  display: flex;
  height: 40px;
  align-items: center;
  font-size: 16px;
}

.collapse-btn {
  float: left;
  width: 60px;
  text-align: center;
  height: 100%;
  cursor: pointer;
  line-height: 40px;
}

.logo {
  float: left;
  margin-left: 5px;
  line-height: 40px;
  color: rgb(250, 249, 249);
}

.comp {
  font-size: 16px;
  font-weight: 700;
  line-height: 40px;
  padding-top: 1px;
}

.symb {
  font-size: 19px;
}

.tit {
  font-size: 14px;
}

.main-header {
  position: relative;
  box-sizing: border-box;
  border-bottom: 1px solid #4c4b4c;
  font-size: 16px;
  color: #525659;
  height: 22px;
  background-image: linear-gradient(-90deg,
      #525659 0%,
      #525659 50%,
      px x #525659 100%),
    linear-gradient(#27bdff, #27bdff);
  background-blend-mode: normal, normal;
}

.main-title {
  height: 50px;
  line-height: 26px;
  font-size: 16px;
  overflow: hidden;
}

.main-toggle {
  position: relative;
  display: inline-block;
  width: 16px;
  height: 16px;
  cursor: pointer;
  color: rgba(66, 70, 73, 0.86);
  margin: 3px 10px;
}

.main-userInfo {
  position: relative;
  float: right;
  right: 12px;
  margin-top: 3px;
}

.main-body {
  background: #343434;
  overflow: auto;
  padding: 5px;
}

.main-tree {
  background-color: #525659;
  margin-right: 5px;
}

.toggle-bar {
  border-top: 1px solid #4f4d4f;
  height: 20px;
  font-size: 16px;
  line-height: 15px;
  margin-bottom: 0px;
  background: #727276;
}

a:link,
a:visited {
  color: rgba(66, 70, 73, 0.86);
  font-size: 16px;
}

.textStyle {
  font-family: MicrosoftYaHei-Bold;
  font-size: 14px;
  font-weight: bold;
  font-stretch: normal;
  line-height: 30px;
  letter-spacing: 0px;
  color: #d8d8d8;
}

.textStyle2 {
  font-family: MicrosoftYaHei-Bold;
  font-size: 13px;
  font-weight: bold;
  letter-spacing: 0px;
  margin-left: 5px;
  margin-top: 7px;
  color: #ff9502;
}

.textStyle3 {
  font-family: MicrosoftYaHei;
  font-size: 16px;
  font-weight: normal;
  letter-spacing: 0px;
  color: #868686;
}

.f-column,
.f-row {
  background-color: #525659;
}
</style>

<style>
.el-button:focus,
.el-button:hover {
  background-color: transparent !important;
  background: transparent !important;
}

.el-button:focus,
.el-button:hover {
  border-color: transparent !important;
}

.el-input-group__append,
.el-input-group__prepend {
  background-color: #6f7373;
  color: #ffffff;
  border: 1px solid transparent !important;
}

.el-input--mini .el-input__inner {
  height: 22px !important;
  line-height: 22px !important;
}

.input-with-select>>>.el-input__inner {
  height: 20px !important;
  line-height: 20px !important;
}

.input-with-select {
  height: 20px !important;
  line-height: 20px !important;
}

.el-popper[x-placement^="bottom"] .popper__arrow:after {
  border-bottom-color: #525659 !important;
}

.el-popper[x-placement^="bottom"] .popper__arrow {
  border-bottom-color: #202020 !important;
}

.tabs-header-bottom .tabs-narrow li.tabs-last,
.tabs-header-narrow,
.tabs-header-narrow .tabs-narrow,
.tabs-narrow li.tabs-last {
  background-color: #343434;
}

.panel-body {
  background-color: transparent !important;
}

.el-badge__content--warning {
  background-color: #5a585d;
}

.tabs-header,
.tabs-tool {}

.tabs {
  background-color: #5a5e61;
  border-color: #3d3d3d;
}

.tabs-title {}

.tabs-title:hover {
  color: chocolate !important;
}

.tabs li {}

.color-change {
  animation: colorChange 0.3s infinite alternate;
}

@keyframes colorChange {
  from {
    color: #07c160;
  }

  to {
    color: #07c16149;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/Index.vue